import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ResetPasswordService } from '../reset-password.service';

@Component({
  selector: 'app-reset-old-password',
  templateUrl: './reset-old-password.component.html',
  styleUrls: ['./reset-old-password.component.css'],
})
export class ResetOldPasswordComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private serviceAuth: ResetPasswordService,
    private router: Router,
  ) {
    this.loginForm = this.fb.group({
      password: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{7,}$/,
          ),
          Validators.minLength(7),
        ],
      ],
    });
  }

  image_key = environment.client_env;
  //@ts-ignore
  imageUrl = environment[this.image_key]['sidebar_image'];
  loginForm: FormGroup;
  emailId: '';
  token: '';
  password: String = '';
  errorMessageUserName = '';
  errorMessagePassword = '';
  errorMsg = 'Error';
  submited = false;
  failedAuth = false;
  showMessage = false;
  ngOnInit() {}

  get f() {
    return this.loginForm.controls;
  }
  onSubmit(form: FormGroup) {
    this.submited = true;
    this.emailId = JSON.parse(localStorage.getItem('resetPasswordData'))[
      'email_address'
    ];
    this.token = JSON.parse(localStorage.getItem('token'));
    this.serviceAuth
      .resetOwnersPassword(this.emailId, form.value['password'], this.token)
      .then((result) => {
        if (result['success'] === '1') {
          this.showMessage = true;
        } else if (
          result['success'] == '0' &&
          result['message'] == 'Login Failed'
        ) {
          this.router.navigate(['/login']);
        } else {
          this.errorMsg = result['message'];
          this.failedAuth = true;
        }
      })
      .catch((error) => {});
  }
  resetForm() {
    this.submited = false;
    this.failedAuth = false;
  }
  navigation() {
    this.router.navigateByUrl('/login');
  }
}
